export default __webpack_public_path__ + "static/media/Flag_of_Tuvalu.ce741c29.svg";